import { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import "./CheckoutForm.css";
import { useGlobalState } from '../../Contexts/GlobalStateContext';
const CheckoutForm = forwardRef((props, ref) => {
  const stripe = useStripe();
  const elements = useElements();
  const name = props.name;
  const zipCode = props.postalCode;
  const [isFocused, setIsFocused] = useState(false);

  const { setErrorVisible, setErrorMessage, setLoading } = useGlobalState();
  
  const handleChange = (event) => {
    props.onError("");
  }

  const handleFocus = () => {
    setIsFocused(true);
  }

  const handleBlur = () => {
    setIsFocused(false);
  }

  useImperativeHandle(ref, () => ({
    handleCreditSubmit() {
      return handleCreditSubmit();
    }
  }));

  const handleCreditSubmit = async () => {
    //console.log("handleCreditSubmit");
    if (!stripe || !elements) {
      return;
    }
    setLoading(true);
    const cardElement = elements.getElement(CardElement);
    //console.log(name, cardElement, 'name, cardElement')
    try {
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: {
          name: name,
          address: {
            postal_code: zipCode
          }
        }
      });
      console.log('paymentMethod:', paymentMethod);
      setLoading(false);
      if (error) {
        setErrorMessage(error.message);
        setErrorVisible(true);
        props.onError(error.message);
        props.onCardValidation(false);
        return Promise.reject(error.message);
      }
      const last4 = paymentMethod.card.last4; 
      props.onCardValidation(true, last4); 
      //console.log('stripe data:!!!!!',paymentMethod);
      
      return Promise.resolve({...paymentMethod, validation:true});
    } catch (error) {
      console.log('error:', error);
      setLoading(false);
      return Promise.reject(error);
    }
  };
  return (
    <div className={`CheckoutForm-container ${isFocused ? 'focus': ''}`}>
      <CardElement onFocus={handleFocus} onBlur={handleBlur} onChange={handleChange} id='payment-element' />
    </div>
  );
});
export default CheckoutForm;
